import PropTypes from 'prop-types'

import {
  CREATE_BUTTON_LABEL,
  BETA_FREE_LABEL,
  CAP_REACHED_TOOLTIP,
  REPORTS_CAP_TOOLTIP,
  SURVEY_IN_FIELD_TOOLTIP
} from '@aytm/app/stats/page/sidebar/reports/lib/skipperGuidedReportsConst'

import { Button } from 'primereact/button'

import UnlockLink, { HintRow } from '@aytm/app/stats/page/sidebar/reports/components/SkipperUnlockLink'

// The panel header lays its controls out on the PrimeFlex grid; the shared hint row takes them
// from the host so the same row also fits the report-settings flyout.
const ROW_CLASS = 'p-field p-col-12'

// Three feature states (window.features.skipper_guided_report.status):
//   hidden   ('off')      -> null here; ReportsPanel renders the legacy fork button instead
//   available('available')-> purchasable: paywall upsell link, gated on isSurveyCompleted
//   purchased('on')       -> the Create button, gated on isSurveyCompleted, the in-flight cap and
//                            the survey's saved-report ceiling,
//                            with the "Free while in Beta" callout on hover when betaFree is set
// `disabled` is derived as "not on", so it is true exactly when hidden or available already is and
// never produces a rendering of its own.
const SkipperGuidedReportButton = ({ feature, betaFree, atInflightCap, atReportsCap, isSurveyCompleted, onCreate }) => {
  if (!feature || feature.hidden) return null

  if (feature.available || feature.disabled) {
    return <UnlockLink onPackage={feature.onPackage} isSurveyCompleted={isSurveyCompleted} className={ROW_CLASS} />
  }

  const tooltip = !isSurveyCompleted
    ? SURVEY_IN_FIELD_TOOLTIP
    : atReportsCap
      ? REPORTS_CAP_TOOLTIP
      : atInflightCap
        ? CAP_REACHED_TOOLTIP
        : null

  const disabled = atInflightCap || atReportsCap || !isSurveyCompleted

  // One callout, never two: a disabled button explains why, an enabled one offers the beta note.
  const hint = null !== tooltip ? tooltip : betaFree ? BETA_FREE_LABEL : null

  return (
    <HintRow hint={hint} className={ROW_CLASS}>
      <Button
        className="p-button-stat p-button-rounded"
        label={CREATE_BUTTON_LABEL}
        icon={<i className="icon-aytmfd-skipper" />}
        disabled={disabled}
        onClick={disabled ? null : onCreate}
      />
    </HintRow>
  )
}

SkipperGuidedReportButton.propTypes = {
  feature: PropTypes.object,
  betaFree: PropTypes.bool,
  atInflightCap: PropTypes.bool,
  atReportsCap: PropTypes.bool,
  isSurveyCompleted: PropTypes.bool,
  onCreate: PropTypes.func
}

SkipperGuidedReportButton.displayName = 'SkipperGuidedReportButton'

export default SkipperGuidedReportButton
